import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { BlueprintGrid } from "../components/BlueprintGrid";

const ComingNext = () => (
    <div className="flex min-h-screen flex-col bg-ink text-white">
        <Navbar />
        <main className="relative flex flex-1 items-center overflow-hidden">
            <BlueprintGrid />
            <div className="relative mx-auto w-full max-w-[1600px] px-6 py-36 md:px-10 lg:px-16">
                <p className="font-mono text-[13px] tracking-[0.3em] text-accent">
                    IN DRAWING
                </p>
                <h1
                    data-testid="coming-next-headline"
                    className="mt-8 max-w-2xl text-4xl font-light leading-[1.1] md:text-6xl"
                >
                    This page is still on the drawing board.
                </h1>
                <p className="mt-6 max-w-md text-sm leading-relaxed text-mist">
                    The next chapter of BuildEase is being prepared. In the
                    meantime, return to the homepage.
                </p>
                <Link
                    to="/"
                    data-testid="coming-next-home-link"
                    className="mt-10 inline-flex items-center gap-2 border border-white/25 px-6 py-3 text-sm text-white transition-colors duration-300 hover:border-accent hover:text-accent"
                >
                    <ArrowLeft className="h-4 w-4" />
                    Back to Home
                </Link>
            </div>
        </main>
        <Footer />
    </div>
);

export default ComingNext;
